import React from 'react';
import AppShell from '../../components/app-shell/app-shell';  
import PublicShell from '../../components/app-shell/public-shell';
import PublicMarkdown from '../../components/markdown/public-markdown';
import WhyCalligraphyDotOrg from "../../components/landing-pages/why-calligraphy-dot-org";
import markdown from './why-calligraphy-dot-org.md';

export default function() {
  return (
    <AppShell
      seoTitle="Why Calligraphy.org"
      description="Since 2012 Calligraphy.org has been the premiere source for online calligraphy classes."
    >
      <PublicShell>
        <WhyCalligraphyDotOrg />
        <PublicMarkdown markdown={markdown} />
      </PublicShell>
    </AppShell>
  );
}
